import React from "react";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-lg md:text-2xl font-semibold text-white">{title}</h2>
    <div className="text-sm md:text-base text-white/70 leading-relaxed space-y-3">
      {children}
    </div>
  </section>
);

export default function Privacy() {
  return (
    <main className="min-h-screen bg-[#0b0b0b] text-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <h1 className="text-3xl md:text-5xl font-bold mb-3">Privacy Policy</h1>

        <div className="space-y-10">
          <Section title="1. What this policy covers">
            <p>
              This Privacy Policy explains how Pluckr ("we", "us") collects,
              uses, and shares information when you use our website, dashboard,
              API, and MCP products.
            </p>
          </Section>

          <Section title="2. Information we collect">
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Account data:</strong> email address, hashed password,
                verification status.
              </li>
              <li>
                <strong>Usage and diagnostics:</strong> basic event/analytics and
                product usage data.
              </li>
              <li>
                <strong>API key metadata:</strong> we store API keys as secure
                hashes (not the raw key), plus creation time and last-used time.
              </li>
              <li>
                <strong>Payment data:</strong> paid plan purchases are processed
                by payment providers (e.g. Razorpay). We do not store full card
                details on our servers.
              </li>
            </ul>
          </Section>

          <Section title="3. How we use information">
            <ul className="list-disc pl-6 space-y-2">
              <li>provide and secure the service (auth, rate limiting);</li>
              <li>send transactional emails (verification, security notices);</li>
              <li>operate billing and plan entitlements for MCP access;</li>
              <li>improve product reliability and user experience.</li>
            </ul>
          </Section>

          <Section title="4. Analytics">
            <p>
              We may use analytics tools (for example PostHog) to understand how
              users interact with the product. This may include page views,
              clicks, and feature usage.
            </p>
          </Section>

          <Section title="5. Emails">
            <p>
              We send transactional emails for account verification and
              essential service communication. We may use an email delivery
              provider (for example Brevo) to send these emails.
            </p>
          </Section>

          <Section title="6. Sharing and disclosure">
            <p>We may share information with:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                service providers who help run Pluckr (hosting, email,
                analytics);
              </li>
              <li>
                payment processors (for processing subscriptions and purchases);
              </li>
              <li>
                law enforcement or regulators when required by applicable law.
              </li>
            </ul>
          </Section>

          <Section title="7. Data retention">
            <p>
              We keep data only as long as necessary for the purposes described
              above, including security and compliance.
            </p>
          </Section>

          <Section title="8. Security">
            <p>
              We use reasonable security measures to protect your data. However,
              no system is 100% secure.
            </p>
          </Section>

          <Section title="9. Your choices">
            <p>
              You can access and update your account information in the
              dashboard. You can also delete API keys you no longer use.
            </p>
          </Section>

          <Section title="10. Contact">
            <p>
              Questions about privacy? Contact us at{' '}
              <a className="text-[#9be38f] hover:underline" href="mailto:support@pluckr.ai">
                support@pluckr.ai
              </a>.
            </p>
          </Section>
        </div>
      </div>
    </main>
  );
}
